import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFeedBack } from "../../../context/FeedBackContext";
import useAxios from "../../../hooks/useAxios";
import useCategories from "../../../hooks/useCategories";
import handleLoadSelectOptions from "../../../util/loadSelectValues";
import mapValues from "../../../util/mapValues";
import AsyncSelect from 'react-select/async';
import useUsers from "../../../hooks/useUsers";
import { Button, Modal } from "react-bootstrap";
import update from 'immutability-helper';
import { FaTimes, FaImage } from "react-icons/fa"; // Agregué icono de imagen
import { getTomorrowDate } from "../../../util/format";

const CategoriesCreate = () => {

    const navigate = useNavigate();
    const { setCustomAlert, setLoading } = useFeedBack();
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [currentUsers, setCurrentUsers] = useState([]);

    const [filters, setFilters] = useState({
        search: '',
        perPage: 10,
        page: 1
    });

    const [categoriesFilters, setCategoriesFilters] = useState({
        page: 1,
        perPage: 10,
        path: '',
        orderBy: 'path,ASC'
    });

    const [data, setData] = useState({
        name: '',
        parent_id: '',
        description: '',
        image: null, // Nuevo estado para la imagen
        users: []
    });

    // IMPORTANTE: Al enviar archivos, a veces es necesario cambiar headers, 
    // pero Axios suele detectarlo si enviamos FormData.
    const [{ data: createData, loading: createLoading, error: createError }, createCategory] = useAxios({ url: `/categories`, method: 'POST' }, { manual: true, useCache: false });

    const [{ users, loading: usersLoading, numberOfPages }, getUser] = useUsers({ params: filters, options: { useCache: false } });

    // Previsualización de imagen (Opcional, para que veas qué subiste)
    const [imagePreview, setImagePreview] = useState(null);

    const [currentCategories, setCurrentCategories] = useState([]);

    const [{ categories, numberOfPages: categoriesNumberOfPages, loading: loadingCategories }] = useCategories({ params: categoriesFilters }, { useCache: false });

    useEffect(() => {
        setCurrentCategories(old => [...old, ...categories]);
    }, [categories])

    useEffect(() => {
        setCurrentUsers((old) => [...old, ...users])
    }, [users])

    useEffect(() => {
        setCurrentUsers([]);
        setFilters((old) => ({ ...old, page: 1, ignoreIds: data?.users?.map(user => user?.id) }))
    }, [data.users])

    useEffect(() => {
        if (createData) {
            setCustomAlert({
                title: '¡Operacion Exitosa!',
                severity: 'success',
                message: 'La categoría y su imagen fueron creadas exitosamente.',
                show: true
            });
            navigate('/categorias');
        }
    }, [createData])

    useEffect(() => {
        if (createError) {
            setCustomAlert({
                title: 'Error',
                severity: 'danger',
                message: 'Ha ocurrido un error al guardar.',
                show: true
            });
        }
    }, [createError])

    const handleSubmit = (e) => {
        e?.preventDefault?.();

        if (createLoading) {
            return;
        }

        // --- CAMBIO IMPORTANTE: USAR FORMDATA PARA ENVIAR IMAGEN ---
        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('description', data.description || '');
        if (data.parent_id) formData.append('parentId', data.parent_id);


        // Adjuntar imagen si existe
        if (data.image) {
            formData.append('image', data.image);
        }

        // Adjuntar usuarios (los arrays en FormData se envían así)
        data.users.forEach((user, index) => {
            formData.append(`userIds[${index}][id]`, user.id);
            if (user?.remove_on) formData.append(`userIds[${index}][remove_on]`, user.remove_on);
        });

        // Enviamos el formData en lugar del objeto JSON simple
        createCategory({
            data: formData,
            // Axios a veces necesita que le digamos que es multipart, 
            // aunque a menudo lo detecta automático.
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    const handleChange = (e) => {
        // Lógica para manejar la subida de imagen y su previsualización
        if (e.target.type === 'file') {
            const file = e.target.files[0];
            setData((oldData) => ({ ...oldData, image: file }));

            if (file) {
                setImagePreview(URL.createObjectURL(file));
            } else {
                setImagePreview(null);
            }
        } else {
            setData((oldData) => ({
                ...oldData,
                [e.target.name]: e.target.value
            }));
        }
    }

    const handleUser = (user) => {
        setData((old) => ({ ...old, users: [...old.users, user] }));
    }

    const handleRemove = (index) => {
        const newArrayValues = update(data?.users, { $splice: [[index, 1]] });
        setData((old) => ({ ...old, users: newArrayValues }));
    }

    const handleArrayChange = (e, index, arrayName) => {
        const newArrayValues = update(data?.[arrayName], { [index]: { [e.target.name]: { $set: e.target.value } } });
        setData((oldData) => {
            return {
                ...oldData,
                [arrayName]: newArrayValues
            }
        });
    }

    const handleCategory = (categoryId) => {
        if (data?.parent_id == categoryId) {
            setData((old) => ({ ...old, parent_id: '' }));
        } else {
            setData((old) => ({ ...old, parent_id: categoryId }));
        }
    }

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h4 className="card-title">Crear Categoría con Imagen</h4>
                </div>
                <div className="card-body">
                    <div className="basic-form">
                        <form onSubmit={handleSubmit}>
                            <div className="row mb-5">
                                <div className="form-group mb-3 col-md-12">
                                    <label>Nombre</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre de la categoría"
                                        name="name"
                                        value={data?.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group mb-3 col-md-12">
                                    <div className="col-md-12 mb-3">
                                        <div className="row align-items-center mb-1">
                                            <div className="col-md-6">
                                                <label className="fw-bold">
                                                    Categoría Padre
                                                </label>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buscar..."
                                                    value={categoriesFilters?.path}
                                                    onChange={(e) => {
                                                        setCurrentCategories([]);
                                                        setCategoriesFilters(old => ({ ...old, path: e.target.value }));
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <ul class="list-group" style={{ maxHeight: 300, overflow: 'auto' }}>
                                            {
                                                currentCategories?.map((category, i) => {
                                                    const level = category?.path?.split("->").length - 1;
                                                    return (
                                                        <li class="list-group-item py-1">
                                                            <input
                                                                class={`form-check-input me-1 ms-${level > 0 ? level + 1 : 0}`}
                                                                type="checkbox"
                                                                checked={data?.parent_id == category?.id}
                                                                value={category?.id}
                                                                onChange={() => handleCategory(category?.id)}
                                                                id={`category-check-${category?.id}`}
                                                            />
                                                            <label
                                                                class={`form-check-label ${level === 0 ? 'fw-bold text-primary' : 'fw-bold'}`}
                                                                for={`category-check-${category?.id}`}
                                                            >
                                                                {category?.path}
                                                            </label>
                                                        </li>
                                                    )
                                                })
                                            }
                                            {
                                                !loadingCategories && currentCategories?.length < 1 ?
                                                    <li class="list-group-item text-center">
                                                        No se encontrarón resultados.
                                                    </li>
                                                    :
                                                    null
                                            }
                                            {
                                                loadingCategories ?
                                                    <li class="list-group-item text-center">
                                                        <div class="spinner-border text-primary" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </li>
                                                    :
                                                    null
                                            }
                                            {
                                                !loadingCategories && categoriesNumberOfPages > categoriesFilters?.page ?
                                                    <li class="list-group-item text-center">
                                                        <button
                                                            onClick={() => setCategoriesFilters((old) => ({ ...old, page: old?.page + 1 }))}
                                                            type="button"
                                                            className="btn btn-primary"
                                                        >
                                                            Cargar más
                                                        </button>
                                                    </li>
                                                    :
                                                    null
                                            }
                                        </ul>
                                    </div>
                                </div>

                                {/* --- NUEVO CAMPO DE IMAGEN --- */}
                                <div className="form-group mb-3 col-md-6">
                                    <label>Imagen de Categoría (Banner)</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="image"
                                        accept="image/*"
                                        onChange={handleChange}
                                    />
                                    <small className="text-muted">Se recomienda imagen horizontal (ej: 800x200px)</small>
                                </div>

                                <div className="form-group mb-3 col-md-6 d-flex align-items-center justify-content-center">
                                    {imagePreview ? (
                                        <div className="text-center p-2 border rounded">
                                            <p className="mb-1 text-xs text-muted">Vista previa:</p>
                                            <img src={imagePreview} alt="Preview" style={{ maxHeight: '100px', maxWidth: '100%' }} />
                                        </div>
                                    ) : (
                                        <div className="text-muted text-center border p-3 rounded bg-light w-100">
                                            <FaImage className="me-2" /> Sin imagen seleccionada
                                        </div>
                                    )}
                                </div>
                                {/* ----------------------------- */}

                                <div className="form-group mb-3 col-md-12">
                                    <label>Descripción</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Descripción breve"
                                        name="description"
                                        value={data?.description}
                                        onChange={handleChange}
                                    />
                                </div>
                                {
                                    !data?.parent &&
                                    <div className="col-md-12">
                                        <h4 className="text-center">
                                            Responsables
                                        </h4>
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Nombre</th>
                                                        <th>Remover automaticamente el:</th>
                                                        <th className="text-end">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data?.users?.map((user, i) => {
                                                            return (
                                                                <tr key={`usuario-${user?.id}`}>
                                                                    <td>
                                                                        {user?.id}
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <img
                                                                                src={user?.imagePath}
                                                                                height={40}
                                                                                width={40}
                                                                                className="rounded-circle"
                                                                                style={{ objectFit: 'cover' }}
                                                                            />
                                                                            <div>
                                                                                <b>
                                                                                    {user?.name}
                                                                                </b>
                                                                                <p className="mb-0">
                                                                                    {user?.documentNumber}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            min={getTomorrowDate()}
                                                                            type="date"
                                                                            className="form-control"
                                                                            value={user?.remove_on}
                                                                            name="remove_on"
                                                                            onChange={(e) => handleArrayChange(e, i, 'users')}
                                                                        />
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <button type="button" className="btn btn-danger" onClick={() => handleRemove(i)}>
                                                                            <FaTimes />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    <tr >
                                                        <td colSpan={4} className="text-center">
                                                            <button type="button" onClick={() => setShowUsersModal(true)} className="btn btn-primary">
                                                                Agregar usuario
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="mb-3 d-flex justify-content-end">
                                <Link to={`#`} onClick={() => { navigate(-1) }} className="btn btn-danger mx-2">
                                    Cancelar
                                </Link>
                                <button disabled={createLoading} type="submit" className="btn btn-primary mx-2">
                                    {createLoading ? 'Guardando...' : 'Crear'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Modal de usuarios se mantiene igual, solo copié lo necesario del render principal */}
            <Modal size="lg" show={showUsersModal} onHide={() => setShowUsersModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Usuarios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="form-control"
                        value={filters?.search}
                        onChange={(e) => {
                            setFilters((old) => ({ ...old, search: e.target.value, page: 1 }))
                            setCurrentUsers([]);
                        }}
                    />
                    <br />
                    <div className="list-group" style={{ maxHeight: 400, overflow: 'auto' }}>
                        {currentUsers?.length > 0 ?
                            currentUsers?.map((user) => (
                                <button
                                    key={`seleccionar-usuario-${user?.id}`}
                                    type="button"
                                    className="list-group-item list-group-item-action d-flex align-items-center gap-2"
                                    onClick={() => handleUser(user)}
                                >
                                    <img src={user?.imagePath} height={40} width={40} className="rounded-circle" style={{ objectFit: 'cover' }} alt="user" />
                                    <div>
                                        <b>{user?.name}</b>
                                        <p className="mb-0">{user?.documentNumber}</p>
                                    </div>
                                </button>
                            )) :
                            !usersLoading && <div className="list-group-item text-center"><h4>No se encontraron resultados.</h4></div>
                        }
                        {usersLoading && <div className="text-center p-3">Cargando...</div>}
                        {
                            !usersLoading && numberOfPages > filters?.page ?
                                <div className="list-group-item text-center">
                                    <button className="btn btn-primary" onClick={() => setFilters((old) => ({ ...old, page: old?.page + 1 }))}>
                                        Cargar más
                                    </button>
                                </div>
                                :
                                null
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUsersModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default CategoriesCreate;